export default "__VITE_ASSET__0e451f72__"